import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { textFormList } from '@/lib/formItem';
import { required } from '@/lib/rule';
import { FormItem } from '@/interfaces/lib/model';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection9Form',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  condition: {
    type: String,
    required: true,
  },
  physicalCondition: {
    type: String,
    required: true,
  },
  form: {
    type: String,
    required: true,
  },
},
  emits: ["update:isValid", "update:condition", "update:physicalCondition", "update:form"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:condition', data: string): void;
  (e: 'update:physicalCondition', data: string): void;
  (e: 'update:form', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  appearance: '外観 / Appearance',
  physicalState: '物理的状態 / Physical State',
  form: '形状・性状 / Form',
  enterToConfirm: 'Enterで入力項目を確定',
});



const formSection9 = ref<string>('');



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateCondition = (e: string | FormItem): void => {
  emits('update:condition', e.value ?? e);
};

const updatePhysicalCondition = (e: string | FormItem): void => {
  emits('update:physicalCondition', e.value ?? e);
};

const updateForm = (e: string | FormItem): void => {
  emits('update:form', e.value ?? e);
};

onMounted((): void => {
  if (formSection9.value) {
    formSection9.value.validate();
  }
});

return { __sfc: true,m, formSection9, emits, updateIsValid, updateCondition, updatePhysicalCondition, updateForm, textFormList, required }
}

})